import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { PropTypes } from 'prop-types';
import withRouter from 'shared/utils/WithRouter';
import { withStyles } from '@material-ui/core/styles';

export const styles = {
	buttonDiv: {
		textAlign: 'center',
	},
	headline: {
		textAlign: 'center',
	},
	message: {
		padding: '15px 0',
	},
	paper: {
		width: '100%',
		maxWidth: '800px',
		height: 'auto',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '8px',
	},
	paperDiv: {
		padding: '25px',
	},
};

const NotFound = ({ classes, history }) => (
	<Paper elevation={6} className={classes.paper}>
		<div className={classes.paperDiv}>
			<Typography type="headline" gutterBottom className={classes.headline}>
				Oooh, something unexpected happened.
			</Typography>
			<Typography type="body1" className={classes.message}>
				Sorry, this isn&apos;t what we want. Let&apos;s go back to get what we really want.
			</Typography>
			<div className={classes.buttonDiv}>
				<Button variant="contained" color="primary" onClick={() => props.router.navigate('/now')}>
					Okay
				</Button>
			</div>
		</div>
	</Paper>
);

NotFound.propTypes = {
	classes: PropTypes.shape({}).isRequired
};

export default withRouter(withStyles(styles, { name: 'NotFound' })(NotFound));
